import Skeleton from "components/BaseWidgets/skeleton";
import ProfileCard from "../ProfileCard";

function Header({ isPremium, user = [], isLoading, setManagedPhoto }) {
  return (
    <div className="flex flex-col gap-6 mb-10">
      <div className="flex flex-col gap-1">
        <h1 className="font-title-large fw-700 leading-3 text-black">
          My profile
        </h1>
        <p className="font-body-lg fw-500 leading-5">
          Update your details, preferences, and interests to find the perfect
          match.
        </p>
      </div>
      {isLoading ? (
        <Skeleton label={false} height={232} />
      ) : (
        <ProfileCard
          profile={user}
          setManagedPhoto={setManagedPhoto}
          profilePic={user?.profile_image}
          userName={user?.name}
          religion={user?.religion?.name || ""}
          profession={user?.profession?.name || ""}
          livesIn={user?.location || ""}
          isPremium={isPremium}
          userHeight={user?.height}
          profileId={user?.aec_id}
          userAge={user?.age}
          aec_id={user?.aec_id}
          idVerification={user?.verification_type}
          createdBy={user?.created_for}
        />
      )}
    </div>
  );
}

export default Header;
